import React, { useEffect } from 'react';
import './Autoridades.css';

import jorgeQuinteros from '../Imagenes/autoridades/Jorge Quinteros.webp';
import benjaminKuchudis from '../Imagenes/autoridades/ING. KUCHUDIS.webp';
import joseGundlach from '../Imagenes/autoridades/ING. ALFREDO GUNDLASH .webp';
import alfredoRomano from '../Imagenes/autoridades/ALFREDO ROMANO.webp';
import luisFernandez from '../Imagenes/autoridades/Contador. L. FERN\u00C1NDEZ .webp';
import florenciaNani from '../Imagenes/autoridades/ING. NANI.webp';
import americoFernandez from '../Imagenes/autoridades/LIC. AMERICO FERNANDEZ.webp';
import directorFoto from '../Imagenes/autoridades/Director.webp';
import matiasCampana from '../Imagenes/autoridades/Matias Campana.webp';

const autoridades = [
  {
    cargo: 'Director',
    nombre: 'Ing. Angel Marcelo Cancellieri',
    correo: 'marcelocancellieri@dpatuc.com',
    foto: directorFoto
  },
  {
    cargo: 'Secretaria General',
    nombre: 'Arq. Jorge Quinteros',
    correo: 'secretariageneral@dpatuc.com',
    foto: jorgeQuinteros
  },
  {
    cargo: 'Servicio Administrativo Financiero',
    nombre: 'Cr. Luis Fernandez',
    correo: 'saf@dpatuc.com',
    foto: luisFernandez
  },
  {
    cargo: 'Estudios y Proyectos',
    nombre: 'Ing. Florencia Nanni',
    correo: 'estudiosyproyectos@dpatuc.com',
    foto: florenciaNani
  },
  {
    cargo: 'Planeamiento',
    nombre: 'Ing. Benjamin Kuchudis',
    correo: 'planeamientos@dpatuc.com',
    foto: benjaminKuchudis
  },
  {
    cargo: 'Personal',
    nombre: 'Romano Alfredo',
    correo: 'personal@dpatuc.com',
    foto: alfredoRomano
  },
  {
    cargo: 'Informatica',
    nombre: 'Matias Campana',
    correo: 'sistemas@dpatuc.com',
    foto: matiasCampana
  },
  {
    cargo: 'Obras por Contrato',
    nombre: 'Ing. Jose Gundlach',
    correo: 'obrasporcontrato@dpatuc.com',
    foto: joseGundlach
  },
  {
    cargo: 'Obras por Administracion',
    nombre: 'Lic. Americo Fernandez',
    correo: 'obrasporadministracion@dpatuc.com',
    foto: americoFernandez
  }
];

const director = autoridades[0];
const resto = autoridades.slice(1);

const PersonaCard = ({ persona, destacada = false }) => (
  <article className={`autoridad-card${destacada ? ' autoridad-card-destacada' : ''}`}>
    <div className="autoridad-foto-wrap">
      <img src={persona.foto} alt={persona.cargo} className="autoridad-foto" />
    </div>
    <div className="autoridad-info">
      <span className="autoridad-cargo">{persona.cargo}</span>
      <h3 className="autoridad-nombre">{persona.nombre}</h3>
      <a className="autoridad-mail" href={`mailto:${persona.correo}`}>
        {persona.correo}
      </a>
    </div>
  </article>
);

const Autoridades = () => (
  <main className="autoridades-page">
    <section className="autoridades-hero">
      <div className="autoridades-shell reveal-on-scroll">
        <h1>Autoridades</h1>
        <p>Equipo directivo y responsables de las distintas areas de la Direccion Provincial del Agua.</p>
      </div>
    </section>

    <section className="autoridades-content">
      <div className="autoridades-shell">
        <div className="autoridad-director reveal-on-scroll">
          <PersonaCard persona={director} destacada />
        </div>

        <div className="autoridades-grid">
          {resto.map((persona) => (
            <div key={persona.correo} className="reveal-on-scroll">
              <PersonaCard persona={persona} />
            </div>
          ))}
        </div>
      </div>
    </section>
  </main>
);

const AutoridadesPage = () => {
  useEffect(() => {
    const targets = document.querySelectorAll('.autoridades-page .reveal-on-scroll:not(.visible)');
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -25px 0px' }
    );

    targets.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  return <Autoridades />;
};

export default AutoridadesPage;
